import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type User from "./User";
import type UserShiftSpec from "./UserShiftSpec";

@Model()
class UserShift extends ApplicationRecord {
  static jsonapiType = "user_shifts";

  @Attr() endTime: number;

  @Attr() externalId: string;

  @Attr() rosterId: number;

  @HasMany() specifications: UserShiftSpec[];

  @Attr() startTime: number;

  @BelongsTo() user: User;
}

export default UserShift;
